import moment from "moment";
import React from "react";
import ItineraryDay from "./ItineraryDay";
import { ItinerarySidebarItem, LinkedItineraryItems } from "./utils";

interface Props {
  item: ItinerarySidebarItem
  artist: server.dto.ArtistSmall
  appointments: server.dto.PlannerDay[]
  startMoment: moment.Moment
  endMoment: moment.Moment

  linkedItems: LinkedItineraryItems
  toggleLinked: (appointment: server.dto.PlannerAppointment) => void

  canCreateNewAppointment: boolean
  canLinkUnlinkTravel: boolean
  canLinkUnlinkShow: boolean
}

const Itinerary = (props: Props) => {
  const [hoveringOver, setHoveringOver] = React.useState<server.dto.PlannerAppointment>(null);

  return (<table className="s1_table s1_itinerarysidebar">
    <tbody>
      {props.appointments.map(appDate =>
        <ItineraryDay
          artist={props.artist}
          item={props.item}
          key={moment.utc(appDate.date).valueOf()}
          dayAppointments={appDate}
          linkedItems={props.linkedItems}
          toggleLinked={props.toggleLinked}
          onHoveringOver={setHoveringOver}
          hoveringOver={hoveringOver}
          canCreateNewAppointment={props.canCreateNewAppointment}
          canLinkUnlinkTravel={props.canLinkUnlinkTravel}
          canLinkUnlinkShow={props.canLinkUnlinkShow}
        />)}
    </tbody>
  </table>);
};

export default Itinerary;